import React, { useState, useEffect, useRef } from "react";
import { debounce } from "lodash";
import { useSearch } from "../../Contexts/SearchContext";
import FilterDrawerAccordion from "./FilterDrawerAccordion/FilterDrawerAccordion";
import FilterDrawerToggle from "./FilterDrawerToggle/FilterDrawerToggle";
import FilterDrawerButtons from "./FilterDrawerButtons/FilterDrawerButtons";
import SearchBar from "../SearchBar/SearchBar";
import "./FilterDrawer.scss";
import LevelTwoFilterDrawerAccordion from "./LevelTwoFilterDrawerAccordion/LevelTwoFilterDrawerAccordion";
import FilterDrawerCategoryAccordion from './FilterDrawerCategoryAccordion/FilterDrawerCategoryAccordion'

const FilterDrawer = ({
  postSearchHandler,
  getSuggestionHandler,
  placeholderText,
}) => {
  const { state, dispatch } = useSearch();
  const searchAndFilterContainerRef = useRef(null);
  const filterDrawerButtonsRef = useRef();
  const [filteredLabels, setFilteredLabels] = useState([])

  const {
    filterContainerIsVisible,
    searchTerm,
    filterDrawerIsOpen,
    searchBarHasFocus,
    filterJson,
    sortTypeApplied,
  } = state;

  const [isActive, setIsActive] = useState(true);
  let isActiveClass = isActive ? " active" : "";

  const hideFilterContainer = () => {
    dispatch({ type: "UPDATE_FILTER_CONTAINER_IS_VISIBLE", payload: false });
  };

  const closeFilterDrawer = () => {
    dispatch({ type: "UPDATE_FILTER_DRAWER_IS_OPEN", payload: false });
  };

  const openFilterDrawer = () => {
    dispatch({ type: "UPDATE_FILTER_DRAWER_IS_OPEN", payload: true });
  };

  const toggleFilterDrawer = () => {
    dispatch({
      type: "UPDATE_FILTER_DRAWER_IS_OPEN",
      payload: !filterDrawerIsOpen,
    });
  };
  useEffect(() => {
    if (filterDrawerIsOpen) {
      document.body.style.overflow = "hidden"; // Prevent scrolling
    } else {
      document.body.style.overflow = "auto"; // Enable scrolling again
    }

    // Cleanup when the component is unmounted or the drawer closes
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [filterDrawerIsOpen]);
  //close drawer on esc press down
  useEffect(() => {
    const handleEscapeKey = (event) => {
      if (event.code === "Escape") {
        hideFilterContainer();
      }
    };

    document.addEventListener("keydown", handleEscapeKey);
    return () => document.removeEventListener("keydown", handleEscapeKey);
  });

  //scroll
  useEffect(() => {
    var searchContainerOffset =
      searchAndFilterContainerRef.current.parentElement.offsetTop;
    const handleScroll = (event) => {
      if (window.innerWidth <= 768) {
        if (window.scrollY > searchContainerOffset) {
          searchAndFilterContainerRef.current.classList.add("sticky");
          if (
            window.innerHeight <
            searchAndFilterContainerRef.current.offsetHeight
          ) {
            filterDrawerButtonsRef.current.classList.add("sticky");
          } else {
            filterDrawerButtonsRef.current.classList.remove("sticky");
          }
        } else {
          searchAndFilterContainerRef.current.classList.remove("sticky");
          filterDrawerButtonsRef.current.classList.remove("sticky");
        }
      }
    };
    document.addEventListener("scroll", handleScroll);
    return () => document.removeEventListener("scroll", handleScroll);
  });

  // Close filter drawer if clicked outside the drawer
  useEffect(() => {
    var searchContainerOffset =
      searchAndFilterContainerRef.current.parentElement.offsetTop;
    const handleClickOutsideFilter = (event) => {
      if (
        filterContainerIsVisible &&
        !FilterDrawerRef.current.contains(event.target)
      ) {
        hideFilterContainer();
      }

      if (window.innerWidth <= 768) {
        if (searchAndFilterContainerRef.current.classList.contains("sticky")) {
          if (
            window.innerHeight <
            searchAndFilterContainerRef.current.offsetHeight
          ) {
            filterDrawerButtonsRef.current.classList.add("sticky");
          } else {
            filterDrawerButtonsRef.current.classList.remove("sticky");
          }
        } else {
          if (window.scrollY > searchContainerOffset) {
            searchAndFilterContainerRef.current.classList.add("sticky");
          }
        }
      }
    };

    document.addEventListener("click", handleClickOutsideFilter);
    return () =>
      document.removeEventListener("click", handleClickOutsideFilter);
  });

  let filterContainerIsVisibleClass = filterContainerIsVisible
    ? " cmp-product-finder__filter-drawer-container--visible"
    : "";
  let filterDrawerIsOpenClass = filterDrawerIsOpen ? " open" : "";
  let showStartTypingPromptClass =
    searchBarHasFocus && (!searchTerm || searchTerm.length === 0)
      ? " show-start-typing-prompt"
      : "";

  return (
    <>
      <div
        className={`cmp-product-finder__search-and-filters-container${
          searchBarHasFocus ? " search-in-progress" : ""
        }${showStartTypingPromptClass}${
          filterDrawerIsOpen ? " filter-drawer-open" : ""
        }`}
        ref={searchAndFilterContainerRef}
      >
        <div className="cmp-product-finder__search-container">
          <SearchBar
            postSearchHandler={postSearchHandler}
            getSuggestionHandler={getSuggestionHandler}
            searchLabel="Find a product: "
            placeholderText={placeholderText}
          />
        </div>
        <div className="cmp-site-search__filter-drawer-heading">Filters</div>
        <div
          className={`cmp-product-finder__filter-drawer-container${filterContainerIsVisibleClass}${
            searchBarHasFocus ? " hidden" : ""
          }`}
        >
          <div className="cmp-product-finder__filter-dropdown-heading-container">
            <div
              className={`cmp-product-finder__filter-dropdown-heading main-heading${filterDrawerIsOpenClass}`}
              onClick={toggleFilterDrawer}
            >
              Filter Products<span className="chevron"></span>
            </div>
          </div>
          <div
            className={`cmp-product-finder__filter-drawer${filterDrawerIsOpenClass}`}
          >
            <div className="filter-drawer-inner">
              <div
                className={`cmp-accordion__item${
                  isActive ? " open" : ""
                } contains-dropdowns`}
              >
                <button
                  aria-expanded={isActive ? "true" : "false"}
                  aria-controls={"accordion-item-0"}
                  className="cmp-accordion__title-button"
                  onClick={() => setIsActive(!isActive)}
                >
                  <div className="cmp-accordion__dropdown-heading">
                    <div className="cmp-accordion__title">
                      Products & Services
                    </div>
                    <div className="cmp-accordion__selected-filters-heading"></div>
                    <span className={`chevron${isActiveClass}`}></span>
                  </div>
                </button>
                <div className="cmp-accordion__content" id={"accordion-item-0"}>
                  <ul>
                    <li className="cmp-accordion__content-item">
                      {filterJson &&
                        filterJson.productsAndServices?.dropdowns?.map(
                          (dropdown, index) => (
                            <LevelTwoFilterDrawerAccordion
                              data={dropdown}
                              index={index}
                              setFilteredLabels={setFilteredLabels}
                            />
                          )
                        )}
                    </li>
                  </ul>
                </div>
              </div>
              
              <FilterDrawerCategoryAccordion
                filterJson={filterJson}
                label={"Categories"}
                subMenuClass={""}
                index={1}
                labels={filteredLabels}
              />
              
              <FilterDrawerAccordion
                data={filterJson.vendors?.dropdowns[0]}
                sortTypeApplied={sortTypeApplied}
                subMenuClass={""}
                index={1}
              />
              <FilterDrawerAccordion
                data={filterJson.billingCycle?.dropdowns[0]}
                sortTypeApplied={sortTypeApplied}
                subMenuClass={""}
                index={2}
              />
              <FilterDrawerAccordion
                data={filterJson.promotions?.dropdowns[0]}
                sortTypeApplied={sortTypeApplied}
                subMenuClass={""}
                index={3}
              />
              <FilterDrawerToggle data={filterJson.onlinePurchase} index={0} />
            </div>
            <FilterDrawerButtons ref={filterDrawerButtonsRef} />
          </div>
        </div>
      </div>
    </>
  );
};

export default FilterDrawer;
